import { screenResizerChecker } from '@src/utils/screen-resizer-checker';
import { ScreensInt } from '@tailwindConfig/screens.config';

document.addEventListener('DOMContentLoaded', function (event) {
  const sectionWithParralax = (section, index) => {
    const headerHeight = document.querySelector('header').offsetHeight;
    let top = section.offsetTop;
    let sectionHeight = section.offsetHeight;
    const imgBig = section.querySelector('.img-big-parralax');
    const imgMiddle = section.querySelector('.img-middle-parralax');
    const imgSmall = section.querySelector('.img-small-parralax');
    const imgAlone = section.querySelector('.img-alone-parralax');
    const cardContainer = section.querySelectorAll('.hero-animation-cards img');

    const insideSection = () => {
      top = section.offsetTop;
      sectionHeight = section.offsetHeight;
      if (index === 0) {
        if (window.scrollY > top && window.scrollY < top + sectionHeight - headerHeight) {
          const value = window.scrollY - top;
          parralaxEffect(value);
        }
      } else if (window.scrollY > top - (headerHeight * 3) && window.scrollY < top + sectionHeight - headerHeight) {
        const value = window.scrollY - top + headerHeight * 3;
        parralaxEffect(value);
      }
    };

    const parralaxEffect = (value) => {
      if (imgMiddle) {
        imgBig.style.transform = `translateY(-${value * 0.1}px)`;
        imgMiddle.style.transform = `translateY(${value * 0.1}px)`;
        imgSmall.style.transform = `translateY(-${value * 0.1}px)`;
      } else if (imgSmall) {
        if (window.location.pathname == "/fr/homepage-va") {
          imgBig.style.transform = `translateY(${value * 0.1}px)`;
          imgSmall.style.transform = `translateY(-${value * 0.1}px)`;
        } else if (window.location.pathname.match(/\/((fr|en)\/financing)$/)) {
          const scaleValue = (value * 0.01) >= 1 ? 0.025 : -0.025;
          imgBig.style.transform = `translateY(${value * 0.1}px) rotate(-${value * 0.01}deg) scale(${1.025 + scaleValue})`;
          imgSmall.style.transform = `translateY(-${value * 0.2}px) rotate(${value * 0.02}deg) scale(${0.975 - scaleValue})`;
        } else {
          imgBig.style.transform = `translateY(-${value * 0.1}px)`;
          imgSmall.style.transform = `translateY(${value * 0.1}px)`;
        }
      } else if (imgAlone) {
        imgAlone.style.transform = `translateY(-${value * 0.1}px)`;
      } else if (cardContainer) {
        cardContainer.forEach((card, index) => {
          card.style.transition = 'transform 0.5s ease-out';
          if (index === 0) {
            const result = 100 + value * -0.5;
            card.style.transform = `translateY(${result <= 0 ? 0 : result}px)`;
          } else if (index === 2) {
            const result = -100 + value * 0.5;
            card.style.transform = `translateY(${result >= 0 ? 0 : result}px)`;
          }
        });
      }
    };

    const parralaxOnScroll = () => {
      document.addEventListener('scroll', insideSection);
    };
    const removeParralaxEffect = () => {
      document.removeEventListener('scroll', insideSection);
    };
    screenResizerChecker(() => removeParralaxEffect(), () => parralaxOnScroll(), ScreensInt.md);
  };
  document.querySelectorAll('.parralax-section').forEach((section, index) => {
    sectionWithParralax(section, index);
  });
});
